import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Select, Switch } from 'antd';
import useApi from '../../hooks/useApi';

const { TextArea } = Input;

const ModalAdd = ({ visible, onCancel, onConfirm }) => {
  const [form] = Form.useForm();
  const [departamentos, setDepartamentos] = useState([]);

  const { callApi: addDashboard } = useApi('https://vision.alfama.com/api/add/dashboards', {
    method: 'POST',
    includeToken: true,
    successMessage: 'Dashboard adicionado com sucesso!',
    errorMessage: 'Erro ao adicionar Dashboard'
  });

  const { callApi: viewDepartamentos } = useApi('https://vision.alfama.com/api/view/departamentos/ativos', { 
    includeToken: true,
  });

  useEffect(() => {
    const fetchDepartamentos = async () => {
      try {
        const response = await viewDepartamentos();
        if (response && Array.isArray(response)) {
          const formattedDepartamentos = response.map(departamento => ({
            value: departamento.departamento_id,
            label: departamento.nome_departamento
          }));
          setDepartamentos(formattedDepartamentos);
        }
      } catch (error) {
        console.error('Erro ao buscar departamentos:', error);
      }
    };

    fetchDepartamentos();
  }, []);

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      // Converte o valor booleano do switch para 0 ou 1
      const formattedValues = {
        ...values,
        has_rls: values.has_rls ? 1 : 0
      };
      await addDashboard(formattedValues);
      form.resetFields();
      onConfirm(true);
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao adicionar dashboard:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="Adicionar Dashboard"
      open={visible}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Adicionar"
      cancelText="Cancelar"
      maskClosable={false}
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ has_rls: false }}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do dashboard' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="departamento"
              label="Departamento"
              rules={[{ required: true, message: 'Por favor, selecione um departamento' }]}
            >
              <Select
                placeholder="Selecione um departamento"
                options={departamentos}
                loading={departamentos.length === 0}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="descricao"
              label="Descrição"
              rules={[{ required: true, message: 'Por favor, insira a descrição do dashboard' }]}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={9}>
            <Form.Item
              name="workspace_id"
              label="Workspace ID"
              rules={[{ required: true, message: 'Por favor, insira o Workspace ID' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              name="report_id"
              label="Report ID"
              rules={[{ required: true, message: 'Por favor, insira o Report ID' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="has_rls"
              label="RLS"
              valuePropName="checked"
            >
              <Switch 
                checkedChildren="Sim" 
                unCheckedChildren="Não"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAdd;